import { Component } from '@angular/core';
import { CardComponent } from '@group24ag/flowkit';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faFile } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-ui-card',
  imports: [CardComponent],
  template: `
    <div>
      <h1 class="heading-title">Card</h1>
      <div class="flex flex-col gap-5">
        <flk-card
          class="w-[500px]"
          title="Process Information"
          description="The public face of this process"
          [icon]="['far', 'file']">
          <p>Basic card content</p>
        </flk-card>

        <flk-card
          class="w-[500px]"
          title="Process Information"
          description="The public face of this process"
          [showDivider]="false"
          [icon]="['far', 'file']">
          <p>Basic card content</p>
        </flk-card>

        <flk-card
          class="w-[500px]"
          title="Process Information"
          [icon]="['far', 'file']">
          <p>Basic card content</p>
        </flk-card>

        <flk-card class="w-[500px]" [icon]="['far', 'file']">
          <p>Basic card content</p>
        </flk-card>

        <flk-card class="w-[500px]" title="Process Information">
          <p>Basic card content</p>
        </flk-card>

        <flk-card class="w-[500px]">
          <p>Basic card content</p>
        </flk-card>
      </div>
    </div>
  `,
})
export class UICardComponent {
  constructor(library: FaIconLibrary) {
    library.addIcons(faFile);
  }
}
